import { render, staticRenderFns } from "./DataTimer.vue?vue&type=template&id=20d2a5c0&scoped=true&"
import script from "./DataTimer.vue?vue&type=script&lang=js&"
export * from "./DataTimer.vue?vue&type=script&lang=js&"
import style0 from "./DataTimer.vue?vue&type=style&index=0&id=20d2a5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2a5c0",
  null
  
)

export default component.exports